import React from "react";
import programmes from "../../data/programmes";
import kaizan from "../../data/kaizan";
import gimba from "../../data/gimba";
import skills from "../../data/skills";
import leanOperational from "../../data/leanoperational";
import teamBuilding from "../../data/teambuilding";
import workplace from "../../data/workplace";
import effective from "../../data/effective";
import training5s from "../../data/training5s";
import iba from "../../data/iba";
import garments from "../../data/garments";

const Programmes = () => {
  return (
    <>
      <div className="bg-blue-800 p-20">
        <h1 className="text-[35px] lg:text-[50px]  text-white font-bold text-center">
          Our Programmes
        </h1>
      </div>
      <div className="container mx-auto p-10">
        <div className="flex justify-center items-center mt-[25px] lg:mt-[50px]">
          <div className="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            Lean Six Sigma Training
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {programmes?.map((programme) => (
            <div>
              <img
                src={programme.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] object-cover rounded-lg"
              />
              <p className="text-center font-bold text-xl mt-[15px] mb-[30px]">
                {programme.companyName}
              </p>
            </div>
          ))}
        </div>

        {/* Lean Six Sigma & Operational Excellence Consulting */}
        <div class="flex justify-center items-center mt-[25px] lg:mt-[50px] ">
          <div class="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            Lean Six Sigma & Operational Excellence Consulting
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {leanOperational?.map((l) => (
            <div>
              <img
                src={l.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] lg:w-[500px] block mx-auto object-cover rounded-lg"
              />
              <p className="text-center font-bold text-xl mt-[15px] mb-[30px]">
                {l.companyName}
              </p>
            </div>
          ))}
        </div>
        {/* IBA- Dhaka University Training Lean Six Sigma and Kaizen */}
        <div class="flex justify-center items-center mt-[25px] lg:mt-[50px]">
          <div class="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            Lean Six Sigma and Kaizen Training at IBA- Dhaka University
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {iba?.map((i) => (
            <div>
              <img
                src={i.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] object-cover rounded-lg"
              />
              <p className="text-center font-bold text-xl mt-[15px] mb-[30px]">
                {i.companyName}
              </p>
            </div>
          ))}
        </div>

        {/* Kaizan */}
        {/* <div class="flex justify-center items-center mt-[25px] lg:mt-[50px]">
          <div class="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            Kaizen Training
          </div>
        </div> */}
        {/* <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {kaizan?.map((k) => (
            <div>
              <img
                src={k.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] object-cover rounded-lg"
              />
            </div>
          ))}
        </div> */}

        {/* Soft Skills Training */}
        <div class="flex justify-center items-center mt-[25px] lg:mt-[50px]">
          <div class="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            Soft Skills Training
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {skills?.map((s) => (
            <div>
              <img
                src={s.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] object-cover rounded-lg"
              />
              <p className="text-center font-bold text-xl mt-[15px] mb-[30px]">
                {s.companyName}
              </p>
            </div>
          ))}
        </div>
        {/* Kaizen Training */}
        <div class="flex justify-center items-center mt-[25px] lg:mt-[50px]">
          <div class="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            Kaizen Training
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {kaizan?.map((k) => (
            <div>
              <img
                src={k.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] object-cover rounded-lg"
              />
              <p className="text-center font-bold text-xl mt-[15px] mb-[30px]">
                {k.companyName}
              </p>
            </div>
          ))}
        </div>

        {/* 5s & Kaizen Training */}
        <div class="flex justify-center items-center mt-[25px] lg:mt-[50px]">
          <div class="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            5s & Kaizen Training
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {training5s?.map((t) => (
            <div>
              <img
                src={t.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] object-cover rounded-lg"
              />
              <p className="text-center font-bold text-xl mt-[15px] mb-[30px]">
                {t.companyName}
              </p>
            </div>
          ))}
        </div>

        {/* 5s Training */}
        {/* <div class="flex justify-center items-center mt-[25px] lg:mt-[50px]">
          <div class="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            5S Training
          </div>
        </div> */}
        {/* <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {training5s?.map((t) => (
            <div>
              <img
                src={t.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] object-cover rounded-lg"
              />
            </div>
          ))}
        </div> */}

        {/*Garments Industries Training */}
        {/* <div class="flex justify-center items-center mt-[25px] lg:mt-[50px]">
          <div class="bg-blue-800 text-white font-bold text-xl px-6 py-4">
            Apparel Industries Training
          </div>
        </div> */}
        {/* <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
          {garments?.map((g) => (
            <div>
              <img
                src={g.img}
                alt="Mind Works Programme"
                className="lg:h-[350px] object-cover rounded-lg"
              />
            </div>
          ))}
        </div> */}
      </div>
    </>
  );
};

export default Programmes;
